import React, { useState, useEffect } from "react";
import "./Chapter.css";
import { FaLinkedin } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../../config/firebase";

function Chapter({ onScroll }) {
  const { t } = useTranslation();
  const [chapters, setChapters] = useState([]);

  // Écoute de la base de données Firebase en temps réel
  useEffect(() => {
    const unsubscribe = onSnapshot(collection(db, "chapters"), (snapshot) => {
      const chaptersData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      // Tri par ordre alphabétique de la ville
      chaptersData.sort((a, b) => a.city.localeCompare(b.city));
      setChapters(chaptersData);
    });

    return () => unsubscribe();
  }, []);

  return (
    <section className="chapter-section" onScroll={onScroll}>
      <div className="chapter-header">
        <h2>{t("chapter.title")}</h2>
        <p className="chapter-subtitle">{t("chapter.subtitle")}</p>
      </div>

      <div className="chapter-grid">
        {chapters.map((chapter) => (
          <div key={chapter.id} className="chapter-card">
            {/* Image de la Ville */}
            <div className="card-image-container">
              <img
                src={chapter.image}
                alt={chapter.city}
                className="city-img"
              />
              <div className="image-overlay"></div>
            </div>

            {/* Contenu Textuel */}
            <div className="card-content">
              <h3 className="city-name">{chapter.city}</h3>

              <div className="lead-info">
                <span className="lead-name">{chapter.lead}</span>
              </div>

              {/* Container Bouton LinkedIn */}
              <div className="linkedin-container">
                {chapter.linkedin && (
                  <a
                    href={chapter.linkedin}
                    target="_blank"
                    rel="noreferrer"
                    className="linkedin-big-btn"
                  >
                    <FaLinkedin />
                  </a>
                )}

                {chapter.linkedin2 && (
                  <a
                    href={chapter.linkedin2}
                    target="_blank"
                    rel="noreferrer"
                    className="linkedin-big-btn"
                  >
                    <FaLinkedin />
                  </a>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Chapter;
